/** Grid step for dot clustering: 0.25° ≈ 25 km. */
const CELL_DEGREES = 0.25;

/**
 * The ~25 km cell a point falls in: "lat,lng" rounded to the nearest 0.25°.
 * Dots cluster by it (DotAccumulatorService); a line whose ends share a cell shows
 * no move and is not drawn (ArcLayer).
 */
export function cellKey(lat: number, lng: number): string {
  const snap = (v: number) => Math.round(v / CELL_DEGREES) * CELL_DEGREES;
  return `${snap(lat)},${snap(lng)}`;
}

/**
 * Where to draw something located at (lat, lng): its cell's dot anchor (the average of
 * the distinct places in the cell) when the cell has a dot, else the point itself. Dots,
 * line ends and waypoints all use it, so a line always meets its dot (P-15f).
 */
export function anchorFor(
  cells: Map<string, { anchor?: { lat: number; lng: number } }>,
  lat: number,
  lng: number,
): { lat: number; lng: number } {
  return cells.get(cellKey(lat, lng))?.anchor ?? { lat, lng };
}
